<template>
  <b-tr>
    <!-- cnt animals -->
    <b-td
      class="cell-table medium-column"
      :class="getClassForCell(stocking.count_animals,isFieldInCache(field,year,rowIndex,'count_animals'))"
    >
      <v-text-field
        clearable
        dense
        v-model="cntAnimals"
        hide-details="true"
        :append-icon="
          stocking.count_animals !== null
            ? 'mdi-check-circle-outline'
            : ''
        "
        @click:append="handleClickSubmit('cntAnimals', cntAnimals)"
      >
      </v-text-field>
    </b-td>
    <b-td class="cell-table white">
      <v-btn icon x-small color="black" @click="handleAdd">
        <v-icon>mdi-plus-circle-outline</v-icon>
      </v-btn>
      <v-btn icon x-small color="black" @click="handleDelete" v-if="dataLength > 1">
        <v-icon>mdi-close-circle-outline</v-icon>
      </v-btn>.
    </b-td>
  </b-tr>
</template>
<script>
import { mapMutations, mapGetters,mapActions } from "vuex"
import { Defaults } from "@/store/modules"
import { getClassForCell } from "../utils"
import PracticeChoiceDropdown from "@/components/dropdowns/PracticeChoiceDropdown"

export default {
  name: "RanchStockingRow",
  props: {
    additionView: { type: Boolean, default: false },
    cropId: { type: Number },
    field: { type: String },
    stocking: { type: Object },
    rowIndex: { type: Number },
    dataLength:{type:Number},
    year: { type: String },
  },
  components: {
    PracticeChoiceDropdown,
  },
  data() {
    return {
      getClassForCell,
    }
  },
  computed: {
    ...mapGetters({
      practiceChoices: Defaults.Getters.getPracticeChoices,
      isFieldInCache: Defaults.Getters.isFieldInCache,
    }),
    cntAnimals: {
      get() {
        return this.stocking.count_animals
      },
      set(val) {
        if (val === "") {
          val = null
        }
        let validVal = this.handleValidateValue(val, "number")
        if (validVal) {
          const updatePayload = {
            fieldId: this.field,
            year: this.year,
            crop: this.cropId,
            dataCategory: "stocking",
            dataSetting: "count_animals",
            value: val,
            rowIndex: this.rowIndex,
          }
          this.spreadsheetUpdate(updatePayload)
        }
      },
    },
  },
  methods: {
    ...mapMutations({
      addFieldSettingRow: Defaults.Mutations.addFieldSettingRow,
      deleteNewFieldSetting: Defaults.Mutations.deleteNewFieldSetting,
      updateNewFieldSetting: Defaults.Mutations.updateNewFieldSetting,
      spreadsheetMutate: Defaults.Mutations.spreadsheetMutate,
    }),
    ...mapActions({
      spreadsheetUpdate: Defaults.Actions.spreadsheetUpdate,
    }),
    // typesByMethod(method, existingType) {
    //   if (["IPM", "IWM", "IDM"].includes(method)) {
    //     return this.typeChoices.filter(
    //       c => c.dependent_value === method || c.value === "other"
    //     )
    //   }
    //   return this.typeChoices.filter(
    //       c => c.dependent_value === method || !c.dependent_value
    //   )
    // },
    // unitsByMethod(method) {
    //   return this.unitChoices.filter(
    //     c => c.dependent_value === method || !c.dependent_value
    //   )
    // },
    // cropProtectionChoices(method, type) {
    //   const choices = cropProtectionChoices(method, type)
    //   return choices
    // },
    handleClickSubmit(setting, val) {
      this[setting] = val
    },
    handleCopy() {
      this.$emit("handle-copy", this.stocking)
    },
    handleAdd() {
      const payloadObj = {
        crop_id: this.cropId,
        count_animals:  null ,
        year:this.year,
        defaults_template:this.stocking.defaults_template,
      }
      this.addFieldSettingRow({
        fieldId: this.field,
        cropId: this.cropId,
        dataCategory: "stocking",
        dataObj: payloadObj,
        year: this.year,
      })
    },
    handleDelete() {
      this.deleteNewFieldSetting({
        fieldId: this.field,
        cropId: this.cropId,
        dataCategory: "stocking",
        recordId: this.stocking.id,
        rowIndex: this.rowIndex,
        year: this.year,
      })
    },
    handleValidateValue(val, type, length = 24) {
      function isNumeric(val) {
        return !isNaN(val) && !isNaN(parseFloat(val));
      }

      if (val === null) {
        return true
      }

      if (val.length > length) {
        this.$emit(
          "bad-input",
          "Inputted value length was too long (24 characters allowed)."
        )
        return false
      }

      if (type == "number") {
        if (isNumeric(val)) {
          return true
        } else {
          this.$emit(
            "bad-input",
            "Look out! A numerical value is expected here."
          )
          return false
        }
      } else if (type == "string") {
        return true
      }
    },
    filter(event) {
      event = event ? event : window.event
      let expect = event.target.value.toString() + event.key.toString()

      let validVal = this.handleValidateValue(expect, "number", 24)
      if (!validVal) event.preventDefault()
    },
  },
}
</script>
<style scoped>
.arva-alert {
  background-color: #f7c0be;
}

.cell-table {
  padding: 2px 6px;
}

.pre-gen {
  background-color: #fedb80;
}

.bg-white {
  color: white;
}

.cell-text {
  font-weight: 600;
  color: white;
}

.machine {
  background-color: #c0dce2;
}

.complete {
  background-color: #c7e3c1;
}

.copy-icon {
  cursor: pointer;
  color: #0f9aee;
}

.delete {
  color: #cc0101;
  cursor: pointer;
}

.input-check {
  cursor: pointer;
}

.select-check {
  margin-top: 14px;
  cursor: pointer;
}

.submit-icon {
  color: #c7e3c1;
}

.medium-column {
  width: 140px;
}

.large-column {
  width: 240px;
}

.marge-column {
  width: 180px;
}

.v-input {
  font-size: 18px;
}
</style>
